import React from "react";

export const ErrorBoundary = () => {
  return (
    <main className="flex h-screen flex-col items-center justify-center bg-pink-100">
      <h2 className="mb-10 text-2xl">
        Something went wrong! Please contact support at
        hello@sarahlynnnutrition.com
      </h2>
    </main>
  );
};
